/**
 * Firebase database connectioon configuration
 * And exporting this connected instance for other files
 */

import * as firebase from 'firebase'

const config = {
    apiKey: 'AIzaSyD50ix5PmrUk2aUI0ZKyHlnx6J0r1tJ_L8',
    authDomain: 'myscheduler-c8f00.firebaseapp.com',
    databaseURL: 'https://myscheduler-c8f00.firebaseio.com',
    projectId: 'myscheduler-c8f00',
    storageBucket: 'myscheduler-c8f00.appspot.com',
    messagingSenderId: 423679302725,
    appId: '1:423679302725:web:f25551c34ea46c9abe572c',
    measurementId: 'G-9BX2HV9DV2',
}

firebase.initializeApp(config)

const database = firebase.database()

let googleAuthProvider = new firebase.auth.GoogleAuthProvider()

export { firebase, googleAuthProvider, database as default }
